import styled from "styled-components";

const Card = styled.div.attrs({
  className: "bg-[#FFFFFF] max-w-xl mx-auto py-20 rounded-lg mt-40",
})`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 7rem;
`;

const CardContent = styled.p.attrs({
  className: "mt-10 text-xl text-center",
})`
  padding: 0px 40px 0px 40px;
`;

const CardTitle = styled.p.attrs({
  className: "text-3xl text-center font-bold text-[#DF6865]",
})``;

const Header = styled.div.attrs({
  className:
    "bg-[#343030] h-24 flex md:flex-col justify-center items-center md:items-start sticky top-0 z-10",
})``;

export default {
  Card,
  CardContent,
  CardTitle,
  Header,
};
